import * as React from "react";

import "./step-2-edit-lists.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {scc}            from "@Common/react/state-cascade-change";
import {UseState}       from "@Common/react/use-state";
import {cascadeFind}    from "@Common/utils/cascade";
import {keepOnly}       from "@Common/utils/objects";

import {assistingInstruction} from "../common/assisting-instruction";
import {coopHeader}           from "../common/coop-header";

import {BuildingsTable1} from "./buildings-table/buildings-table";
import {NewAddressModal} from "./buildings-table/common/buildings-table/footer/new-address-modal/new-address-modal";
import {Buttons}         from "./buttons";
import {ContentHeader}   from "./content-header/content-header";

export const Step2EditLists = ({buildingSelector, next}) => cs(
    consumeContext("apis"),
    ["data", (_, next) => UseState({
        initValue: [],
        next,
    })],
    ["addBuilding", ({data, apis}, next) => next(async ({street, building}) => {
        const result = await apis.next.mailing.decondo.retrieveAddresses(building.key);
        data.change((_) => [
            ..._,
            {
                street,
                building,
                summary: keepOnly(result.street, ["begin", "end"]),

                addressList: result.addressList,
            },
        ]);
    })],
    ({addBuilding, data}) => next({
        ready: data.value.length,

        addBuilding,
        render: ({onNext}) => cs(
            ["search", (_, next) => UseState({
                next,
            })],
            ["newAddressModal", (_, next) => NewAddressModal({
                buildingSelector, addBuilding,
                isBuildingExisted: (buildingKey) => data.value.find((r) => r.building.key === buildingKey),
                next,
            })],
            ({search, newAddressModal}) => (
                <div className="step2-edit-lists-9cv">
                    {coopHeader}

                    <div className="content">
                        {ContentHeader({search})}

                        <div className="box">
                            {BuildingsTable1({
                                buildings: data.value,
                                search: search.value,
                                onAddBuilding: () => newAddressModal.show(),
                                onRemoveBuilding: (buildingKey) => {
                                    data.change((_) => _.filter((b) => b.building.key !== buildingKey));
                                },
                                onRemoveAddresses: (addrs, buildingKey) => {
                                    // console.log("addrs", addrs);
                                    // console.log("buildingKey", buildingKey);
                                    // console.log("data.value", data.value);
                                    scc(data, "[*].addressList", (_, {}, {0:b}) => b.building.key !== buildingKey ? _ : _.filter((a1) => addrs.findIndex((a) => a === a1.address2) === -1));
                                    // stateChangeNestedValue(data, [bi,"addressList"], (_) => _.filter((a1) => addrs.findIndex((a) => a === a1.address2) === -1));
                                },
                            })}
                        </div>
                    </div>

                    <div className="footer">

                        <div className="text">
                            {assistingInstruction}
                        </div>
                        <div className="buttons">
                            {Buttons({
                                onNext: !cascadeFind(data.value, "[*].addressList[*]") ? (
                                    null
                                ) : (
                                    () => onNext(data.value)
                                ),
                                onCancel: () => data.onChange([]),
                            })}
                        </div>
                    </div>
                </div>
            ),
        ),
    }),
);
